import {
    NinchatActionType,
    NinchatDescribeRealmQueuesAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatRealmQueuesFoundEvent} from '../types/events'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const describeRealmQueues = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDescribeRealmQueuesAction}`,
    async (arg: NinchatActionParams<NinchatDescribeRealmQueuesAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDescribeRealmQueuesAction

        try {
            return await ninchatClient.send(params) as NinchatRealmQueuesFoundEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
